var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectForkliftCriticalHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "#FF8027"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.662 24.2104V28.9473H30.7743V27.0525L26.7891 24.3858L43.1579 22.0382L38.7153 17.5789H19.4487V14.7368H12.8421V23.2631H19.4487V19.4736H37.9338L39.1541 20.6985L21.267 23.2631H20.3925V28.9473H12.8421V37.4736H15.6735C15.6735 39.5665 17.3637 41.2631 19.4487 41.2631C21.5337 41.2631 23.2239 39.5665 23.2239 37.4736H32.662C32.662 39.5665 34.3522 41.2631 36.4372 41.2631C38.5221 41.2631 40.2124 39.5665 40.2124 37.4736H43.0438V28.9473L41.1562 24.2104H32.662ZM17.5611 21.3683H14.7297V16.6315H17.5611V21.3683ZM22.2801 25.1578H24.54L28.8867 28.0665V28.9473H22.2801V25.1578ZM19.4487 39.3683C18.4079 39.3683 17.5611 38.5183 17.5611 37.4736C17.5611 36.4289 18.4079 35.5789 19.4487 35.5789C20.4895 35.5789 21.3363 36.4289 21.3363 37.4736C21.3363 38.5183 20.4895 39.3683 19.4487 39.3683ZM36.4372 39.3683C35.3964 39.3683 34.5496 38.5183 34.5496 37.4736C34.5496 36.4289 35.3964 35.5789 36.4372 35.5789C37.478 35.5789 38.3248 36.4289 38.3248 37.4736C38.3248 38.5183 37.478 39.3683 36.4372 39.3683ZM34.5496 30.842V26.1052H39.8783L41.1562 29.3123V35.5789H39.6888C39.0347 34.4509 37.831 33.6841 36.4372 33.6841C35.0434 33.6841 33.8396 34.4509 33.1856 35.5789H22.7003C22.0462 34.4509 20.8425 33.6841 19.4487 33.6841C18.0549 33.6841 16.8512 34.4509 16.1971 35.5789H14.7297V30.842H34.5496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectForkliftCriticalHover);
export default __webpack_public_path__ + "static/media/object-forklift-critical-hover.be6ee48a347fa93fea32885cbc296913.svg";
export { ForwardRef as ReactComponent };